import { ReactNode } from 'react';

let showAlertFn: (message: ReactNode) => void = () => {};
let closeAlertFn: () => void = () => {};

export const alertService = {
  init: (showFn: (message: ReactNode) => void, closeFn: () => void) => {
    showAlertFn = showFn;
    closeAlertFn = closeFn;
  },
  show: (message: ReactNode) => {
    showAlertFn(message);
  },
  close: () => {
    closeAlertFn();
  },
};
